module.exports = __webpack_public_path__ + "static/media/TUNE_4530.20087dc1.jpg";